
<div class="container"></div>
<div class="container__error-container">
  <div class="container__error-container__error-card">
     
    <div class="container__error-container__error-card__error-message">
    <!--<h1>{{'error-page.title' | translate}}</h1>-->
    <span class="container__error-container__error-card__error-message__error-icon"></span>
    
    <div class="container__error-container__error-card__error-message__content">
     <!-- <h3 class="error-message__line">{{'error-page.title' | translate}}</h3>-->
    <p class="error-message__line">
      {{'error-page.message1' | translate}}
    </p>
    <p class="error-message__line">
      {{'error-page.message2' | translate}}
      
    </p>
    <span class="error-container__error-card__error-code">{{'error-page.error-code' | translate}}</span>
    </div>
  </div>
</div>
</div>